import { render } from "./CarIcon.vue?vue&type=template&id=37ce852c"
const script = {}

import exportComponent from "C:\\laragon\\www\\carzoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__